import React, { useEffect, useState,useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackLink from "./Back";
import Section from "./Section";
import {SalubrisContext} from './Context';
import SearchMap from "./SearchMap";
import CenterListSearch from "./CenterSearchList";
import GoogleMapReact from 'google-map-react';
import axios from "axios";
import Marker from "./Marker";
import Button from "./Button";
import Loader from "./Loader";
import FullScreen from "./FullScreen";
import { Carousel } from "@trendyol-js/react-carousel";
import ReactTooltip from 'react-tooltip';
import Phone from './Phone';
import JSONLD from "./JsonLD";
import Fax from "./Fax";

import mixpanel from 'mixpanel-browser';
mixpanel.init('dad63d43256c11b54faf7cf812a51631');

const Center = (props) => {

    const {centers, actions} = useContext(SalubrisContext);
    const [center, setCenter] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [fullScreen, setFullScreen] = useState(false);
    const [copiedText, setCopied] = useState(false);
    const [offset, setOffset] = useState(0);
    const tooltipRef = useRef();
    let params = useParams();
    const centerName = params.name;
    let navigate = useNavigate();

    useEffect(() => {

        var config = {
        method: 'get',
        url: `https://app.sal.health/api/location/${centerName}`,
        headers: { 
            'Authorization': 'Bearer 2|'+process.env.REACT_APP_SALUBRIS_API_KEY
        }
        };
        
        mixpanel.track_pageview({"page":`${centerName} Center`});
        mixpanel.track(`${centerName} Center visited`); 
        setLoading(true);
        axios(config).then( res => {

            if(res.data !== false)
            {
                setLoading(false);

                if(Array.isArray(res.data))
                {
                    setCenter(false);
                    actions.setCenters(res.data); 
                }
                else 
                {
                    actions.setCenters(false); 
                    setCenter(res.data);
                }

                const onScroll = () => setOffset(window.pageYOffset);
                // clean up code
                window.removeEventListener('scroll', onScroll);
                window.addEventListener('scroll', onScroll, { passive: true });
                    
                return () => window.removeEventListener('scroll', onScroll);
            }
            else
                navigate('/find-doctors/');
        });
      }, [centerName] );

    const handleImageClick =  (image) => {

        document.body.classList.add('lock')
        setFullScreen(image);
    }

    const hideFullScreen = () => {

        document.body.classList.remove('lock');  
        setFullScreen(false);
    }

    const smothScroll = (section) => {

        const sectionElement = document.querySelector(`#${section}`);
        sectionElement.scrollIntoView( { behavior: 'smooth', block: 'center' } );
    }

    const renderCenterNav = () =>  {

        return (<ul className="cente-subnav">
            {center.services && center.services.length > 0 && <li onClick={()=>smothScroll('services')}>Services</li>}
            {center.physicians && center.physicians.length > 0 && <li onClick={() => smothScroll('physicians')}>Physicians/Staff</li>}
            {center.images && center.images.length > 0 &&<li onClick={() => smothScroll('gallery')}>Gallery</li>}
            <li onClick={() => smothScroll('contact')}>Contact</li>
        </ul>);
    }
    
    const renderCenter = () => {
         
         return (<>
            <JSONLD center={center}></JSONLD>
            <h1 className="margin-top">{center.name}</h1>
            {center.type && center.type.length > 0 && <p>{center.type}</p>}
            {center.logo && <img className="center-logo" alt={center.name} />}
            {renderCenterNav()}
            <div className="center-info-containers margin-top full-width">
                <div className="full-container">
                {renderAddress()}
                {renderContact()}
                </div>
                <div className="full-container">
                    {center.hours && renderHours()}
                    {center.languages && center.languages.length > 0 && renderLanguages()}
                </div>
                {center.services && center.services.length > 0 &&  renderServices()}
                <div className="full-container">
                    {center.plans && center.plans.length > 0 && renderPlans()}
                    {renderAges()}
                </div>
            </div>
            <div className="center-info-containers margin-top full-width">
                {center.physicians && center.physicians.length > 0 && renderPhysicians()}
                {center.images && center.images.length > 0 && renderGallery()}
                {renderContactForm()}
            </div>
         </>);
    }   

    const renderAddress = () => {

        const mapOtions = {
            minZoom: 8,
            maxZoom: 13,
        }

        const addressClickHandle = (address1, address2, city, state, zip) => {
            navigator.clipboard.writeText(`${address1} ${address2} ${city}, ${state} ${zip}`);
            ReactTooltip.show(tooltipRef.current);
            setCopied(true);
            setTimeout(() => {ReactTooltip.hide(tooltipRef.current); setCopied(false);}, 2000);
        };
        
        return (<div className="info-container address-container">
            <div className="address-info">
                <h2>Address</h2>
                <div className={copiedText ? 'address-tooltip only-address' : 'address-tooltip'} ref={tooltipRef}  data-tip="Address Copied!" data-for="address-tooltip" data-event="custom">
                    {center.address_1 && center.address_1.length > 0 && <p onClick={() => addressClickHandle(center.address_1,center.address_2, center.city, center.state, center.zip)} >{center.address_1}</p>}
                    {center.address_2 && center.address_2.length > 0 && <p onClick={() => addressClickHandle(center.address_1,center.address_2, center.city, center.state, center.zip)} >{center.address_2}</p>}
                    {center.city && center.city.length > 0 && <p onClick={() => addressClickHandle(center.address_1,center.address_2, center.city, center.state, center.zip)} >{`${center.city}, ${center.state} ${center.zip}`}</p>}
                </div>
                <a className="get-directions" href={`https://www.google.com/maps/dir//${center.lat},${center.lng}`} target="blank"><label>Get Directions</label></a>
                <ReactTooltip id="address-tooltip"  place="top" type="dark" effect="float" eventOff="click" />
            </div>
            <div className="addressMap" style={{ height: '200px', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyC96mjiOZBVVamIiyLtO72fvJZdFjRF-Qg" }}
                    defaultCenter={{lat:center.lat, lng:center.lng}}
                    options={mapOtions}
                    defaultZoom={12}>
                        <Marker lat={center.lat} lng={center.lng} text={center.name && center.name[0]} ></Marker>
                </GoogleMapReact>
            </div>
        </div>);
    }
    const renderContact = () => {

        return (<div className="info-container">
                <h2>Contact</h2>
                {center.phone && center.phone.length > 0 &&<Phone>{center.phone}</Phone>}
                {center.fax && center.fax.length > 0 && <Fax>{`F: ${center.fax}`}</Fax>}
                {center.website && center.website.length > 0 && <a className="get-directions" href={center.website}><label>Visit Website</label></a>}
        </div>);
    }
    const renderHours = () => {

        const hoursList = Object.keys(center.hours).map((day, index) => <p key={index}><strong>{day}</strong> {`: ${center.hours[day]}`}</p>)
        return (<div className="info-container hours-container">
                <h2>Hours of Operation</h2>
                {hoursList}
        </div>);
    }
    const renderLanguages = () => {

        const languagesList = center.languages.reduce( (alllanguages, language) => alllanguages.length ? `${alllanguages}, ${language}`: language , '');
        return (<div className="info-container languages-container">
            <h2>Languages Spoken</h2>
            <p>{languagesList}</p>
        </div>);
    }
    const renderServices = () => {

        const servicesList = center.services.map((service, index) => <li key={index}>{service}</li>);
        return (<div className="info-container full-container services-container" id="services">
            <h2>Services Provided</h2>
            <ul className="two-columns">
                {servicesList}
            </ul>
        </div>);
    }
    const renderPlans = () => {

        const plansList = center.plans.map((plan, index) => <li key={index}>{plan}</li>);
        return (<div className="info-container plans-container">
            <h2>Health Plans Accepted</h2>
            <ul>
                {plansList}
            </ul>
        </div>);
    }
    const renderAges = () => {

        return (<div className="info-container ages-container">
            <h2>Ages Accepted</h2>
            <p>{`From ${center.age_from} to ${center.age_to}`}</p>
        </div>);
    }
    const renderPhysicians = () => {

        const physiciansList = center.physicians.map((physician, index) => (<div className="physician-info" key={index} id="physicians">
        <div className="physician-image"></div><p>{physician.first_name} {physician.last_name}, {physician.title}</p></div>
        ));

        return (<div className="full-container">
            <h2>Physicians/Staff</h2>
            {physiciansList}
        </div>);
    }
    const renderGallery = () => {

        const imagesList = center.images.map((image, index) => (<img key={index} className="center-image" src={image.link} alt={image.alt} onClick={() => handleImageClick(image) } />));

        return (<div className="full-container" id="gallery">
            <h2>Gallery</h2>
            <Carousel  show={3} slide={1} transition={0.25}>
                {imagesList}
            </Carousel>
            {fullScreen !== false && <FullScreen hideFullScreen={() => hideFullScreen()} image={fullScreen.link} alt={fullScreen.alt} /> }
        </div>);
    }
    const renderContactForm = () => {

        return (<div className="full-container contact-container" id="contact">
            <div className="half">
                <h2>Get in Touch</h2>
                <p>Have any questions? Please contact us and we'll be happy to help.</p>
            </div>
            <div className="half">
                <form>
                    <input type="text" placeholder="Name" />
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Phone" />
                    <textarea placeholder="Message"></textarea>
                    <Button handleClick={()=> {}} extraClasses="float-right transparent">Send</Button>
                </form>
            </div>
        </div>);
    }

    var elements = [];

    if(isLoading)
        elements = [<Loader key={3} />];
    else {

        if(center) {

            elements = [<BackLink key={1} text="back to search" path={-1} />,
            <div className="full-width" key={2}>
                <Section  key={2} extraClasses="no-banner with-padding with-overflow">
                {renderCenter()} 
            </Section>
            </div>];
        }
        else if(centers && centers.length) {

            elements = [    <BackLink key={1} text="back to search" path="/find-doctors" />,
                            <Section  key={2} extraClasses="no-banner with-padding">
                                <h1 className="light"><strong>{params.location} Locations</strong></h1>
                            </Section>,
                            <SearchMap key={3} />,
                            <Section key={4} extraClasses="with-padding">
                                {<CenterListSearch />}   
                                {offset > 500 && <button className="button back-to-map dt" onClick={() =>  window.scrollTo({top: 0, behavior: 'smooth'})}>Back to Map</button>  }       
                            </Section>
                        ];
        }
        else elements = [ <Section key={3} extraClasses="with-padding"><h4>Not Centers match the search criteria</h4></Section> ];
    }
    return (elements);
}

export default Center;